export const testimonials = [
  {
    name: 'Michael T.',
    role: 'Personal Trainer',
    initials: 'MT',
    quote:
      'As a personal trainer, I wanted a clearer way to organize shoulder rehabilitation exercises. Volume 01 gave me a structured progression with mobility, activation, strengthening and stability work.',
  },
  {
    name: 'Jessica R.',
    role: 'Recreational Athlete',
    initials: 'JR',
    quote:
      'After my knee surgery, I needed a clearer way to return to training. Volume 02 gave me exercises by level, with sets, reps and an easy progression to follow.',
  },
  {
    name: 'Brian K.',
    role: 'Physical Education Teacher',
    initials: 'BK',
    quote: 'Volume 03 helped me organize mobility, strength, balance and proprioception exercises much more clearly.',
  },
]
